import React, { useContext, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Zoom } from '@mui/material';
import { ticketsAction, ticketsTransition } from '../../../services/TicketsServices';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { ticketInitialValue } from '../../../view/Landing/CustomerBookTicket/TicketModel';
import { SNACKBAR_OPEN } from '../../../reducers';
import { DispatchContext } from '../../../store';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{ transitionDelay: '150ms' }} ref={ref} {...props} />;
});


export default function RefundPopup(props) {
  const dispatch = useContext(DispatchContext);
  const { open, handleClose, ticketId } = props;
  const [initialValues, setInitialValues] = useState({
    refund_amount: '',
    remarks: '',
  });

  useEffect(() => {
    if (open && ticketId) {
      ticketsAction('get', ticketId)
        .then((res) => {
          const ticket = res?.data || {};
          setInitialValues((prev) => ({
            ...prev,
            ...ticket,
            refund_amount: ticket?.refund_amount || ticket?.payable_amount || ticket?.payment_due || '',
            remarks: ticket?.refund_notes || ticket?.remarks || '',
          }));
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error('Failed to load ticket:', err);
        });
    }
  }, [open, ticketId]);

  const validate = (values) => {
    const errors = {};
    if (!values?.remarks?.trim()) {
      errors.remarks = 'Refund notes is required';
    }
    const amount = Number(values?.refund_amount);
    if (!Number.isFinite(amount) || amount <= 0) {
      errors.refund_amount = 'Refund amount must be greater than 0';
    }
    return errors;
  };

  const onSubmit = async (values) => {
    try {
      await ticketsTransition('put', ticketId, {
        action: 'request_refund',
        refund_amount: Number(values?.refund_amount || 0),
        remarks: values?.remarks || '',
      });

      dispatch({
        type: SNACKBAR_OPEN,
        payload: { isNotify: true, severity: 'success', message: 'Refund requested successfully' },
      });
      handleClose();
    } catch (error) {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {
          isNotify: true,
          severity: 'error',
          message: error?.response?.data?.error || error?.message || 'Failed to request refund',
        },
      });
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth={true}
        maxWidth={'sm'}
      >
        <Formik initialValues={initialValues}
          onSubmit={onSubmit}
          validate={validate}
          validateOnBlur={true} enableReinitialize
        >
          {({ isSubmitting, touched, errors, values, setFieldValue, ...formik }) => (
            <Form>
              <DialogContent>
                <h3>Request Refund</h3>
                {/* <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                  label={'Enter refund note'} name="translation"
                  InputLabelProps={{
                    style: { fontSize: 14, color: '#929191', }
                  }} /> */}
                <Field component={TextField} variant={'standard'} size={'small'} fullWidth label={'Enter refund amount'} name="refund_amount" sx={{ mt: 2 }} />
                <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Enter refund notes'} name="remarks" sx={{ mt: 2 }} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} variant={'outlined'} color={'error'}
                  className={'text-capitalize'}>cancel</Button>
                <Button
                  variant={'contained'}
                  type={'submit'}
                  className={'text-capitalize'}
                  disabled={isSubmitting || !values?.remarks?.trim() || Number(values?.refund_amount) <= 0}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
}